"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LoggingWebClient = exports.LoggingWebClientOptions = void 0;
var browser_logs_1 = require("@datadog/browser-logs");
var LoggingWebClientOptions = (function () {
    function LoggingWebClientOptions() {
    }
    return LoggingWebClientOptions;
}());
exports.LoggingWebClientOptions = LoggingWebClientOptions;
var LoggingWebClient = (function () {
    function LoggingWebClient(options) {
        if (!options) {
            throw new Error('LoggingWebClientOptions must be provided');
        }
        browser_logs_1.datadogLogs.init({
            clientToken: options.clientId,
            site: 'datadoghq.com',
            forwardErrorsToLogs: true,
            sampleRate: 100,
            forwardConsoleLogs: 'all',
            trackSessionAcrossSubdomains: true,
        });
        browser_logs_1.datadogLogs.addLoggerGlobalContext('request_id', options.requestId);
        this.logger = browser_logs_1.datadogLogs.logger;
    }
    LoggingWebClient.prototype.error = function (message, attributes) {
        if (attributes === void 0) { attributes = {}; }
        this.logger.error(message, attributes);
    };
    LoggingWebClient.prototype.warn = function (message, attributes) {
        if (attributes === void 0) { attributes = {}; }
        this.logger.warn(message, attributes);
    };
    LoggingWebClient.prototype.debug = function (message, attributes) {
        if (attributes === void 0) { attributes = {}; }
        this.logger.debug(message, attributes);
    };
    LoggingWebClient.prototype.info = function (message, attributes) {
        if (attributes === void 0) { attributes = {}; }
        this.logger.info(message, attributes);
    };
    LoggingWebClient.prototype.onReady = function (callback) {
        browser_logs_1.datadogLogs.onReady(callback);
    };
    return LoggingWebClient;
}());
exports.LoggingWebClient = LoggingWebClient;
//# sourceMappingURL=logging-web-client.js.map